










import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue';

@Component({
  components: {
    BDropdown,
    BDropdownItem,
  },
})
export default class SimpleDropdown extends Vue {
  @Prop() private icon!: string;
  @Prop() private items!: Object;

  onClick(itemkey: any, item: any) {
    this.$emit('item-click', itemkey, item);
  }
}
